import { createContext, useContext } from 'react'
import { CIOAppProperties } from '~/types/common_cio'

export type RootContextType = Omit<CIOAppProperties, 'SENTRY' | 'FooterNav' | 'totalJobSearchPromo'>

export const RootContext = createContext<RootContextType>({
  url: {
    origin: '',
    pathname: '',
    href: '',
    hostname: '',
    searchParams: {},
  },
  HeaderNav: undefined,
  PlanEntries: undefined,
  cookie_consent: {
    essentialCookies: false,
    analyticalCookies: false,
    marketingAndTrackingCookies: false,
  },
  ENV: {},
})

export const useRootContext = () => {
  return useContext(RootContext)
}
